import {
  AtsVacancyContractTypeEnum,
  AtsVacancyWorkModalityEnum,
} from '@/generated/graphql/types';
import { AtsVacancyWorkScheduleEnum } from '@crehana/compass.knowledgehub/types';
import type { CrehanaTFunction } from '@crehana/i18n';

import type { useTranslationSharedCandidateForm } from './i18n/use-translations';

/**
 * Available work modes for job positions.
 */
export const workModeOptions = (
  t: CrehanaTFunction<
    'WORK_MODE_HYBRID' | 'WORK_MODE_ONSITE' | 'WORK_MODE_VIRTUAL'
  >,
): Record<AtsVacancyWorkModalityEnum, { label: string }> => ({
  [AtsVacancyWorkModalityEnum.Hybrid]: { label: t('WORK_MODE_HYBRID') },
  [AtsVacancyWorkModalityEnum.OnSite]: { label: t('WORK_MODE_ONSITE') },
  [AtsVacancyWorkModalityEnum.Virtual]: { label: t('WORK_MODE_VIRTUAL') },
});
/**
 * Available contract types for job positions.
 */
export const contractOptions = (
  t: ReturnType<typeof useTranslationSharedCandidateForm>['t'],
): Record<AtsVacancyContractTypeEnum, { label: string }> => ({
  [AtsVacancyContractTypeEnum.Practice]: { label: t('CONTRACT_LEARNING') },
  [AtsVacancyContractTypeEnum.FixedTerm]: { label: t('CONTRACT_FIXED') },
  [AtsVacancyContractTypeEnum.Permanent]: { label: t('CONTRACT_INDEFINITE') },
  [AtsVacancyContractTypeEnum.Freelance]: { label: t('CONTRACT_SERVICE') },
  [AtsVacancyContractTypeEnum.Other]: { label: t('CONTRACT_WORK') },
});

/**
 * Work schedule options.
 */
export const workScheduleOptions = (
  t: ReturnType<typeof useTranslationSharedCandidateForm>['t'],
): Record<AtsVacancyWorkScheduleEnum, { label: string }> => ({
  [AtsVacancyWorkScheduleEnum.PartTime]: {
    label: t('WORK_SCHEDULE_PART_TIME'),
  },
  [AtsVacancyWorkScheduleEnum.FullTime]: {
    label: t('WORK_SCHEDULE_FULL_TIME'),
  },
});
